import type { ShopPlatformsQueryResponse } from '~/api/graphql/queries/shopPlatforms.generated';
import type { ShopInfo } from '~/types/shop';

import { create } from 'zustand';

export type ShopPlatform = NonNullable<
  NonNullable<
    NonNullable<NonNullable<ShopPlatformsQueryResponse['shopPlatforms']>['edges']>[number]
  >['node']
>;

export interface ShopAuth {
  shopID: ShopInfo['shopID'];
  token: ShopInfo['token'];
}

export interface IShopStoreState {
  shopInfo?: ShopInfo;
  shopifyLocale?: string;
  shopPlatformGemX?: ShopPlatform | null;
  shopPlatformGemPages?: ShopPlatform | null;
  isMaintenanceMode: boolean;
  isInitIntercom: boolean;
  isInitHotjar: boolean;
}

export interface IShopStoreActions {
  setShopInfo: (shopInfo: ShopInfo) => void;
  setShopPlatformGemX: (shopPlatform: ShopPlatform | null) => void;
  setShopPlatformGemPages: (shopPlatform: ShopPlatform | null) => void;
  setIsMaintenanceMode: (isMaintenanceMode: boolean) => void;
  setIsInitIntercom: (isInitIntercom: boolean) => void;
  setIsInitHotjar: (isInitHotjar: boolean) => void;
  setShopAuth: (payload: ShopAuth) => void;
  setShopifyLocale: (locale: string) => void;
}

export interface IShopStore extends IShopStoreState, IShopStoreActions {}

export const useShopStore = create<IShopStore>()((set) => ({
  shopInfo: undefined,
  shopPlatformGemX: undefined,
  shopPlatformGemPages: undefined,
  shopifyLocale: 'en',
  isMaintenanceMode: false,
  isInitIntercom: false,
  isInitHotjar: false,
  setShopInfo: (shopInfo) => set({ shopInfo }),
  setShopPlatformGemX: (shopPlatformGemX) => set({ shopPlatformGemX }),
  setShopPlatformGemPages: (shopPlatformGemPages) => set({ shopPlatformGemPages }),
  setIsMaintenanceMode: (isMaintenanceMode) => set({ isMaintenanceMode }),
  setIsInitIntercom: (isInitIntercom) => set({ isInitIntercom }),
  setIsInitHotjar: (isInitHotjar) => set({ isInitHotjar }),
  setShopifyLocale: (locale) => set({ shopifyLocale: locale }),
  setShopAuth: (payload) => {
    set((state) => ({
      shopInfo: {
        ...state.shopInfo,
        ...payload,
      },
    }));
  },
}));

export default useShopStore;
